import React from 'react';
import { Time, TIME_FORMAT_HOUR } from '../../components/Time';

export default function (props) {
  const { date, label, timezone } = props;
  return (
    <div className="purchase-date">
      <span className="small-print">
        <i className="fa fa-calendar-o fa-fw" aria-hidden="true" />
        {' '}
        {label}
      </span>
      <br />
      <span><Time time={date} timezone={timezone}/></span>
      <br />
      <span className="small-print"><Time format={TIME_FORMAT_HOUR} time={date} timezone={timezone} /></span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-date.js